import isEmpty from './isEmpty'
import { CookieConstants, ErrorTypes } from '../constants'

class SessionUtil {
  static getIdToken () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('idToken')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static getAccessToken () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('accessToken')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static getDeviceKey () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('deviceKey')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static setTokenCookie () {
    const token = SessionUtil.getAccessToken()
    if (token !== null) {
      SessionUtil.setCookie(CookieConstants.token.key, token, CookieConstants.token.ttlMinutes) // Token Expire is 5 minutes
    } else {
      SessionUtil.setCookie(CookieConstants.token.key, null, 0)
    }
  }

  static setNetworkErrorCookie (errorMessage, isNetworkError = false) {
    const unixTime = errorMessage.split(ErrorTypes.profileLocked)[1]
    const unlockProfileTime = parseInt(unixTime) * 1000
    const unlockDate = new Date(unlockProfileTime)
    const milliseconds = Math.abs(new Date() - unlockDate)
    const minutes = Math.ceil(milliseconds / 60000)

    const cookieObj = {
      isNetworkError,
      date: unlockDate
    }

    SessionUtil.setCookie(CookieConstants.networkError, JSON.stringify(cookieObj), minutes)
  }

  static getTokenCookie () {
    return SessionUtil.getCookie(CookieConstants.token.key)
  }

  static setCookie (cname, cvalue, minutes) {
    const d = new Date()
    d.setTime(d.getTime() + minutes * 60 * 1000)
    const expireTime = d.toUTCString()

    const domain = SessionUtil.getDomain()

    document.cookie = `${cname}=${cvalue};expires=${expireTime};domain=${domain};path=/`
  }

  static getCookie (cname) {
    const name = `${cname}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return null
  }

  static deleteCookie (cname) {
    const d = new Date()
    d.setTime(d.getTime() - 1)
    const expireTime = d.toUTCString()

    const domain = SessionUtil.getDomain()

    document.cookie = `${cname}=;expires=${expireTime};domain=${domain};path=/`
  }

  /**
   * Clears all Cognito identity session items. If multiple usernames sign in during the same session, multiple items are created which can cause issues retrieving auth and ID tokens.
   */
  static clearIdentitySessions () {
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('CognitoIdentityServiceProvider')) {
        window.sessionStorage.removeItem(key)
      }
    }

    return null
  }

  static getDomain () {
    if (window.location.host.includes('localhost')) {
      return 'localhost'
    }

    if (window.location.host.includes('amazonaws')) {
      return '.com.s3.amazonaws.com'
    }

    if (window.location.host.includes('cloudfront')) {
      // Being used for the backward compatibility site
      return window.location.hostname.split('.')[0] + '.cloudfront.net'
    }

    return `.${location.hostname.split('.').reverse()[1]}.${location.hostname.split('.').reverse()[0]}`
  }

  static async wait (milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

  static hasIncompleteOrigination (customerId) {
    const originationCookie = SessionUtil.getCookie(CookieConstants.origination.key + customerId)
    return !isEmpty(originationCookie)
  }
}

export default SessionUtil
